// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ol[data-v-76b5f4b4]{padding-left:0;font-size:inherit;list-style-type:none;ol ol{padding-left:2.2em}}li[data-v-76b5f4b4]{margin:.5em 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
